import React from "react";
import { Box } from "@mui/material";
import Sidebar from "../Common/Sidebar";
import { Outlet } from "react-router-dom";

function AdminLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Sidebar />

      <Box
        sx={{
          flexGrow: 1,
          padding: { sm: "20px", xs: "5px" },
          marginLeft: { sm: "240px", xs: "0" },
          marginTop: { sm: 0, xs: 6 },
          pt: { xs: 3 },
          backgroundColor: "#F8F8F8",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            padding: { sm: 5, xs: 2 },
            borderRadius: "16px",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default AdminLayout;
